<template>
  <CSidebar fixed :minimize="minimize" colorScheme="dark" :show.sync="show">
    <b-link class="c-sidebar-brand d-md-down-none router-link-active" to="/">
      <h2 class="c-sidebar-brand-full">{{ NomeEmpresa(true) }}</h2>
      <h2 class="c-sidebar-brand-minimized">{{ NomeEmpresa(false) }}</h2>
    </b-link>
    <CRenderFunction flat :content-to-render="MontarMenu()" />
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="minimize = !minimize"
    />
  </CSidebar>
</template>

<script>
import Nav from "./_nav";

export default {
  name: "TheSidebar",
  data() {
    return {
      minimize: false,
      show: "responsive"
    };
  },
  mounted() {
    this.$root.$on("toggle-sidebar", () => {
      const sidebarOpened = this.show === true || this.show === "responsive";
      this.show = sidebarOpened ? false : "responsive";
    });
    this.$root.$on("toggle-sidebar-mobile", () => {
      const sidebarClosed = this.show === "responsive" || this.show === false;
      this.show = sidebarClosed ? true : "responsive";
    });
    if (this.$store.state.main.pmauHabilitado === null) {
      this.$store.dispatch("fetchPmauAccess");
    }
    if (this.$store.state.main.pmauModules === null) {
      this.$store.dispatch("fetchPmauPermissions");
    }
  },
  methods: {
    NomeEmpresa(full) {
      let nome = "";
      if (
        this.$store.getters.getAutenticacao &&
        this.$store.getters.getAutenticacao.contaSelecionada &&
        this.$store.getters.getAutenticacao.contaSelecionada.apelido
      )
        nome = this.$store.getters.getAutenticacao.contaSelecionada.apelido;
      else nome = "";

      return full ? nome : nome.charAt(0);
    },
    MontarMenu() {
      let menu = [];
      menu.push({
        _name: "CSidebarNav",
        _children: []
      });
      // console.log(Nav);
      let permissao = this.$store.getters.getAutenticacao.permissoes;
      // console.log(permissao);

      menu[0]._children.push(Nav.Dashboard);

      const inventarioItems = [];
      if (
        Nav.Project.permission &&
        permissao.filter((x) => x.startsWith(Nav.Project.permission)).length > 0
      )
        inventarioItems.push(Nav.Project);

      if (
        Nav.Geolocalizacao.permission &&
        permissao.filter((x) => x.startsWith(Nav.Geolocalizacao.permission))
          .length > 0
      )
        inventarioItems.push(Nav.Geolocalizacao);

      if (
        Nav.GeoPortal.permission &&
        permissao.filter((x) => x.startsWith(Nav.GeoPortal.permission)).length >
          0
      )
        inventarioItems.push(Nav.GeoPortal);

      if (
        Nav.Pergunta.permission &&
        permissao.filter((x) => x.startsWith(Nav.Pergunta.permission)).length >
          0
      )
        inventarioItems.push(Nav.Pergunta);

      if (
        Nav.PerguntaDinamica.permission &&
        permissao.filter((x) => x.startsWith(Nav.PerguntaDinamica.permission))
          .length > 0
      )
        inventarioItems.push(Nav.PerguntaDinamica);

      if (
        Nav.Transferencia.permission &&
        permissao.filter((x) => x.startsWith(Nav.Transferencia.permission))
          .length > 0
      )
        inventarioItems.push(Nav.Transferencia);

      if (
        Nav.Carbono.permission &&
        permissao.filter((x) => x.startsWith(Nav.Carbono.permission)).length > 0
      )
        inventarioItems.push(Nav.EstoqueCarbono);

      if (
        Nav.Carbono.permission &&
        permissao.filter((x) => x.startsWith(Nav.Carbono.permission)).length > 0
      )
        inventarioItems.push(Nav.Carbono);

      if (inventarioItems.length) {
        menu[0]._children.push({
          ...Nav.InventarioDropdown,
          _children: inventarioItems
        });
      }

      const manejoItems = [];
      if (
        Nav.OrdemServico.permission &&
        permissao.filter((x) => x.startsWith(Nav.OrdemServico.permission))
          .length > 0
      )
        manejoItems.push(Nav.OrdemServico);

      if (
        Nav.Equipe.permission &&
        permissao.filter((x) => x.startsWith(Nav.Equipe.permission)).length > 0
      )
        manejoItems.push(Nav.Equipe);

      if (manejoItems.length) {
        menu[0]._children.push({
          ...Nav.ManejoDropdown,
          _children: manejoItems
        });
      }

      const pmauHabilitado = this.$store.getters.isPmauHabilitado;
      const isPmauAdmin = this.$store.getters.isPmauAdmin;
      const pmauItems = [];
      if (pmauHabilitado) {
        // Cada item só aparece se o usuário tem o módulo (Permissões PMAU).
        const has = this.$store.getters.hasPmauModule;
        if (has("criar")) pmauItems.push(Nav.Pmau);
        else if (has("resultado")) pmauItems.push({ ...Nav.Pmau, name: "Resultado do PMAU" });
        if (has("diagnostico")) pmauItems.push(Nav.PmauSurvey);
        if (has("workshop")) pmauItems.push(Nav.PmauWorkshop);
        if (has("audiencia")) pmauItems.push(Nav.PmauPublicHearing);
        if (has("plano_acao")) pmauItems.push(Nav.PmauActionPlan);
        if (has("configuracao")) pmauItems.push(Nav.PmauConfiguracao);

        // Prompts PMAU: o técnico vê a aba da própria conta; o admin vê também a do padrão.
        if (has("configuracao") || has("criar") || isPmauAdmin) pmauItems.push(Nav.PmauPrompts);

        if (isPmauAdmin) {
          pmauItems.push(Nav.PmauPermissoes);
        }
      }
      if (pmauItems.length) {
        // Objeto novo a cada render — não muta o Nav compartilhado.
        menu[0]._children.push({ ...Nav.PmauDropdown, _children: pmauItems });
      }

      //           if (
      //   Nav.Gaau.permission &&
      //   permissao.filter((x) => x.startsWith(Nav.Gaau.permission)).length > 0
      // )
      //   menu[0]._children.push(Nav.Gaau);

      //   if (
      //   Nav.Inventory.permission &&
      //   permissao.filter((x) => x.startsWith(Nav.Inventory.permission)).length > 0
      // )
      //   menu[0]._children.push(Nav.Inventory);

      const configuracoesItems = [];

      // Fica visível mesmo com o PMAU desabilitado na conta atual — é por
      // aqui que o admin o habilita de novo.
      if (isPmauAdmin) configuracoesItems.push(Nav.PmauContas);

      if (
        Nav.Parametro.permission &&
        permissao.filter((x) => x.startsWith(Nav.Parametro.permission)).length >
          0
      )
        configuracoesItems.push(Nav.Parametro);

      if (
        Nav.Usuarios.permission &&
        permissao.filter((x) => x.startsWith(Nav.Usuarios.permission)).length >
          0
      )
        configuracoesItems.push(Nav.Usuarios);

      if (
        Nav.GrupoUsuario.permission &&
        permissao.filter((x) => x.startsWith(Nav.GrupoUsuario.permission))
          .length > 0
      )
        configuracoesItems.push(Nav.GrupoUsuario);

      if (configuracoesItems.length) {
        menu[0]._children.push({
          ...Nav.ConfiguracoesDropdown,
          _children: configuracoesItems
        });
      }

      return menu;
    }
  }
};
</script>

<style lang="scss">
.sidebar-image-logo {
  max-width: 85%;
  max-height: 85%;
  margin: 0.5rem 1rem 0.5rem 1rem;
}

.sidebar-image-small-logo {
  max-width: 85%;
  max-height: 85%;
  margin: 0.5rem 1rem 0.5rem 1rem;
}
</style>
